module.exports = __webpack_public_path__ + "img/artboard3.375faf76.webp";